export enum ProjectStatusColors {
  PROSPECTING = '#D5D9EB',
  IDENTIFIED = '#FEEE95',
  SURVEYED = '#FEDF89',
  PERMITTING = '#DDD6FE',
  CONSTRUCTION = '#C3E8F3',
  OPERATING = '#CEEAB0',
  ARCHIVED = '#EAECF0'
};
